import axios from '@axios';

const base = '/api/v1/additional-visitors';

export default {
  getVisitors(visitId) {
    return axios.get(`${base}/for-visit/${visitId}`);
  },
};
